import React, { useState } from 'react';
import {
  Form,
  Input,
  Button,
  Typography,
  Upload,
  Select,
  Alert,
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import './DemoAPISection.css';
import {
  checkPassword,
  convertSingingVoice,
} from './DemoAPI';

const { Text } = Typography;
const { Option } = Select;

function DemoAPISection() {
  const [currentPassword, setCurrentPassword] = useState('');
  const [hasValidPassword, setHasValidPassword] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [conversionSuccess, setConversionSuccess] = useState(null);
  const [currentPosition, setCurrentPosition] = useState();

  const handlePasswordSubmit = async (value) => {
    const isValidPassword = await checkPassword(value.password);
    if (isValidPassword) {
      setCurrentPassword(value.password);
      setHasValidPassword(true);
      setPasswordError(false);
    } else {
      setPasswordError(true);
    }
  };

  const handleSingingVoiceSubmit = async (value) => {
    const result = await convertSingingVoice({
      ...value,
      password: currentPassword,
      source: value.source[0].originFileObj,
    });
    if (result.success) {
      setConversionSuccess(true);
      setCurrentPosition(result.position);
    } else {
      setConversionSuccess(false);
    }
  };

  const handleTryAnother = () => {
    setConversionSuccess(null);
  };

  const normFile = (e) => {
    return e.fileList;
  };

  const beforeUpload = () => false;

  const conversionSuccessMsg = (
    <div className="demo-api-section__finish-msg">
      <p>
        Your singing voice conversion request has been sent and being processed.
        You are number <b>{currentPosition}</b> in the queue now.
      </p>
      <p>We will send you an email after the conversion finishes. Thank you for trying our service.</p>
      <Button type="default" onClick={handleTryAnother}>
        Try another
      </Button>
    </div>
  );

  const conversionFailMsg = (
    <div className="demo-api-section__finish-msg">
      <p>Your singing voice conversion request has failed for some reasons.</p>
      <p>If you need further assistance, please contact us. Thank you for trying our service.</p>
      <Button type="default" onClick={handleTryAnother}>
        Try again
      </Button>
    </div>
  );

  return (
    <div className="demo-api-section">
      {hasValidPassword ?
        <>
          {conversionSuccess === true &&
            <Alert message={conversionSuccessMsg} type="success" />
          }
          {conversionSuccess === false &&
            <Alert message={conversionFailMsg} type="error" />
          }
          {conversionSuccess === null &&
            <>
              <div className="demo-api-section__intro">
                <p>Please fill the following fields to tryout our singing voice conversion.</p>
                <p>The estimated conversion time is 3 minutes for each second of your source file, so please only upload short clips for your convenience.</p>
              </div>
              <Form
              layout="vertical"
              className="demo-api-section__form"
              onFinish={handleSingingVoiceSubmit}
              >
                <Form.Item
                  label="Please select a source file to convert:"
                  name="source"
                  valuePropName="fileList"
                  getValueFromEvent={normFile}
                  rules={[{ required: true, message: 'Please select a source file!' }]}
                >
                  <Upload maxCount={1} beforeUpload={beforeUpload}>
                    <Button icon={<UploadOutlined />}>Select File</Button>
                  </Upload>
                </Form.Item>
                <Form.Item
                  label="Please select a target singer:"
                  name="target"
                  rules={[{ required: true, message: 'Please select a target singer!' }]}
                >
                  <Select placeholder="Target singer" className="demo-api-section__select">
                    <Option value="JTAN">JTAN</Option>
                    <Option value="JLEE">JLEE</Option>
                    <Option value="SAMF">SAMF</Option>
                    <Option value="MPOL">MPOL</Option>
                    <Option value="MPUR">MPUR</Option>
                    <Option value="PMAR">PMAR</Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Please enter your email:"
                  name="email"
                  rules={[{ required: true, message: 'Please enter your email!' }]}
                >
                  <Input placeholder="example@mail.com" />
                </Form.Item>
                <Form.Item>
                  <Button type="default" htmlType="submit">Submit</Button>
                </Form.Item>
              </Form>
            </>
          }
        </> :
        <>
          {passwordError && <Text type="danger">Wrong password</Text>}
          <Form
            layout="vertical"
            className="demo-api-section__form"
            onFinish={handlePasswordSubmit}
          >
            <Form.Item
              label="Please input the password:"
              name="password"
              rules={[{ required: true, message: 'Please input the password!' }]}
            >
              <Input.Password placeholder="Password" />
            </Form.Item>
            <Form.Item>
              <Button type="default" htmlType="submit">Submit</Button>
            </Form.Item>
          </Form>
        </>
      }
    </div>
  );
}

export default DemoAPISection;
